import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/center-v2.0.0'

export default reactNode(
	'Center',
	{
		'v2.0.0': v200,
	},
	{ allowChildren: true, docs: '' }
)